import { useInfiniteQuery } from '@tanstack/react-query';
import { customerService } from '../../../services/api';

const PAGE_SIZE = 20;

export const useClientsQuery = (queryOptions) => {
  return useInfiniteQuery({
    queryKey: ['clients', queryOptions],
    queryFn: ({ pageParam = 0 }) =>
      customerService
        .getContacts({
          paginationModel: { page: pageParam, pageSize: PAGE_SIZE },
          ...queryOptions,
        })
        .then((res) => res.data),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.next ? allPages.length : undefined,
    staleTime: 15_000,
    gcTime: 60_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    refetchOnMount: 'always',
  });
};
